module.exports = __webpack_public_path__ + "img/page.28476296.png";